import type { LogEventName } from '@/lib/log-events';

type ClientMetaValue = string | number | boolean | null | string[];

/** Best-effort telemetry; callers never wait for it to finish. */
export function logClientEvent(
  event: LogEventName,
  description?: string,
  meta?: Record<string, ClientMetaValue>,
): void {
  try {
    if (typeof navigator === 'undefined' || navigator.webdriver) return;
    void fetch('/api/log/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event,
        description,
        meta,
        url: meta?.url ?? window.location.pathname + window.location.search,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Serialization and fetch can also fail synchronously.
  }
}
